module.exports = __webpack_public_path__ + "a80dd65703a6a5bee125c254265ef6c6.svg";